// extracted by mini-css-extract-plugin
export var header = "InvoiceHistory_header__OH7Ms";
export var invoiceCaret = "InvoiceHistory_invoiceCaret__m5+Fc";
export var invoiceContainer = "InvoiceHistory_invoiceContainer__LZeIK";
export var invoiceDetails = "InvoiceHistory_invoiceDetails__BNaGB";
export var invoiceDetailsContainer = "InvoiceHistory_invoiceDetailsContainer__kZRtx";
export var invoiceField = "InvoiceHistory_invoiceField__RmVEg";
export var invoiceFieldName = "InvoiceHistory_invoiceFieldName__RaBTX";
export var invoiceFields = "InvoiceHistory_invoiceFields__XZ0hH";
export var invoiceFinancialItem = "InvoiceHistory_invoiceFinancialItem__Vy+c6";
export var invoiceFinancials = "InvoiceHistory_invoiceFinancials__udqQW";
export var invoiceTitle = "InvoiceHistory_invoiceTitle__DOPEo";
export var invoiceValue = "InvoiceHistory_invoiceValue__a-cvd";
export var invoices = "InvoiceHistory_invoices__2Ksqb";
export var itemQuantity = "InvoiceHistory_itemQuantity__5a4a4";
export var lg = "992px";
export var lineItemDetail = "InvoiceHistory_lineItemDetail__WSik-";
export var md = "768px";
export var orderDetails = "InvoiceHistory_orderDetails__ToStE";
export var orderTotal = "InvoiceHistory_orderTotal__FOm5n";
export var paginationContainer = "InvoiceHistory_paginationContainer__PRag4";
export var shared = "\"../shared.module.css\"";